import { serverAxios } from '@/shared/api';

export const logoutApi = async () => {
  return await serverAxios.post('/member/logout/');
};
